import { Injectable } from '@angular/core';

import * as DocumentListingActions from '../store/document-listing.actions';
import * as DocumentListingSelectors from '../store/document-listing.selectors';
import { Store } from '@ngrx/store';
import { IPlaybooksItemDTO } from '../../legal-hub/dto/playbooks-listening.dto';
import { IGuideLineListFilter } from '../../legal-hub/playbooks/playbook-list/playbook-list.component';
import { IPlaybookGuidelineRunItem } from '../../legal-hub/playbooks/playbook-list/plyabbok-guideline-run-tile/playbook-guideline-run-tile.component';
import { IPlaybookListFacadeService } from '../../legal-hub/playbooks/playbook-list/plyabbok-guideline-run-tile/playbook-list.facade.service';
import { BehaviorSubject } from 'rxjs';
import { IGuideLineSuggestion } from '../../general-editor-tabs/legal-hub/suggestion-sidebar/suggestion-sidebar.component';

@Injectable({
  providedIn: 'root'
})
export class DocumentsRightbarPlaybookListFacadeService implements IPlaybookListFacadeService {
  legalHubFilters$ = this._store.select(DocumentListingSelectors.selectLegalHubFilters);
  legalHubSelectedPlaybook$ = this._store.select(DocumentListingSelectors.selectedLegalHubPlaybook);
  rightBarHigherZindex$ = this._store.select(DocumentListingSelectors.rightBarHigherZindex);
  showSuggestions$:BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  guideLineSuggestions$:BehaviorSubject<IGuideLineSuggestion> = new BehaviorSubject<IGuideLineSuggestion>(null);

  constructor(private _store:Store ) { }

  setLegalHubFilters(filters: IGuideLineListFilter){
      this._store.dispatch(DocumentListingActions.setLegalHubFilters({ filters }));
  }

  setLegalHubPlaybook(playbook: IPlaybooksItemDTO){
      this._store.dispatch(DocumentListingActions.selectLegalHubPlaybook({ playbook }));
  }

  setRightBarHigherZindex(higher: boolean):void{
      this._store.dispatch(DocumentListingActions.rightBarHigherZindex({ higher }));
  }

  openLegalHubSidebar(guideLine:IPlaybookGuidelineRunItem): void {
    this.guideLineSuggestions$.next(guideLine.details);
    this.showSuggestions$.next(true);
  }
}